module.exports = __webpack_public_path__ + "static/img/credit_card_support.bf1b622.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payment/credit_card_support.png
// module id = Uib6
// module chunks = 31